module.exports = __webpack_public_path__ + "static/chan2-f15c8738e9488848cb3eea702117469e.webp";